"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var task_1 = require("@alife/task");
var next_1 = require("@alifd/next");
var Cookie = require("js-cookie");
function _uc_verify_sendCodeUsingPost(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, task_1.Util.post("/newHall/uc/verify/sendCode", data)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports._uc_verify_sendCodeUsingPost = _uc_verify_sendCodeUsingPost;
function _uc_account_legalRegisterUsingPost(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, task_1.Util.post("/newHall/uc/account/legalRegister", data)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports._uc_account_legalRegisterUsingPost = _uc_account_legalRegisterUsingPost;
function _app_api_userFacePass_addUserInfoUsingPost(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, task_1.Util.post("/app_api/userFacePass/addUserInfo", data)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports._app_api_userFacePass_addUserInfoUsingPost = _app_api_userFacePass_addUserInfoUsingPost;
function _uc_loginUsingPost(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, task_1.Util.post("/newHall/uc/login", data)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports._uc_loginUsingPost = _uc_loginUsingPost;
var ucCommonDictUsingPost = function (data) { return __awaiter(_this, void 0, void 0, function () {
    var info;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, task_1.Util.post("/newHall/uc/common/dict", data)];
            case 1:
                info = _a.sent();
                return [2 /*return*/, info];
        }
    });
}); };
function getIdCardInfo(type) {
    if (type === void 0) { type = "idtype"; }
    return __awaiter(this, void 0, void 0, function () {
        var info, _a, data, content, options, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ucCommonDictUsingPost({
                            type: type,
                            extras: { accountType: Cookie.get("clientUserType") || "person" },
                        })];
                case 1:
                    info = _b.sent();
                    _a = (info || {}).data, data = _a === void 0 ? {} : _a;
                    content = data.content || [];
                    options = content.map(function (item) { return ({
                        label: item.value,
                        value: item.key,
                    }); });
                    return [2 /*return*/, options];
                case 2:
                    error_1 = _b.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getIdCardInfo = getIdCardInfo;
function doLogin(params, successCB, errorCB) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, success, _b, data, _c, errorMsg, error_2;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, _uc_loginUsingPost(params)];
                case 1:
                    _a = _d.sent(), success = _a.success, _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.errorMsg, errorMsg = _c === void 0 ? "" : _c;
                    if (success && data) {
                        task_1.GovCookie.personSet({
                            psid: data.userId,
                            username: data.userName,
                            type: Cookie.get("clientUserType") || "person",
                        });
                        successCB(data);
                    }
                    else {
                        errorCB();
                        next_1.Message.error(errorMsg);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _d.sent();
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.doLogin = doLogin;
